import React from 'react';
import {withStyles} from "@material-ui/core/styles";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import Button from "@mui/material/Button";
import Hero from "../assets/special/Dragons.jpg";

const muiTheme = createTheme({
    palette: {
        primary: {
            main: "#FF2E28",
        },
        secondary: {
            main: "#FFF",
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontFamily: "montserratbold",
                    fontSize: '1rem',
                    padding: '10px 14px',
                    borderRadius: '4',
                },
            }
        },
    }
});

const useStyles = theme => ({
    paper: {
        [theme.breakpoints.up('lg')]: {
            width: '600px !important',
            maxWidth: '600px !important',
        }
    },
    panel: {
        zIndex: '999',
        width: '100%',
        height: '100%',
        minHeight: '100%',
        display: 'flex',
        backgroundSize: 'cover',
    },
    content: {
        width: '100%',
        height: '100%',
        background: '#FFF',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '34px',
        boxSizing: 'border-box',
    },
    title: {
        fontFamily: 'Divona',
        fontSize: '2.7em',
        lineHeight: '1.2em',
        color: '#7B3938',
    },
    subtitle: {
        fontFamily: 'montserratbold',
        letterSpacing: '0.1em',
        margin: '12px 0',
        textTransform: 'uppercase',
        color: '#2D2824',
    },
    text: {
        width: '100%',
        margin: '0 0 20px 0',
        color: '#2D2824',
    },
    test: {
        width: '100%',

        [theme.breakpoints.up('sm')]: {
            width: '50%',
        },
    },
    footer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    btn: {
        margin: '0 10px',
        textAlign: 'left',
    },
});

class SpecialDialog extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
    }

    render() {
        const { classes } = this.props;
        let self = this;

        const handleClose = () => {
            self.props.onClose();
        };
        
        return (
            <ThemeProvider theme={muiTheme}>

                <Dialog classes={{ paper: classes.paper}} onClose={handleClose} open={self.props.open} PaperProps={{ sx: { borderRadius: "0px" } }}>
                    <div className={classes.panel}>
                        <div className={classes.content}>
                                <div className={classes.title}>New Merch Drop!</div>

                                <div className={classes.subtitle}>Available for pre-order</div>

                            <div className={classes.text}>
                                <img className={classes.test} src={Hero} />
                            </div>

                            <div className={classes.text}>
                                We have exclusive Dragons Club hoodies ready for pre-order. Only available for pickup from the Adelaide Wing Chun Academy.
                            </div>

                                <div className={classes.footer}>
                                    <div className={classes.btn}><a href={"https://buy.stripe.com/5kQ6oA5vg4g8fe5g40d7q0k"} target="_blank"><Button variant="contained">Order Hoodie</Button></a></div>
                                    <div className={classes.btn}><Button onClick={handleClose} variant="outlined">No Thanks</Button></div>
                                </div>

                        </div>
                    </div>
                </Dialog>

            </ThemeProvider>
        )
    }
}

export default withStyles(useStyles)(SpecialDialog)